// ADR 16.10.26p §2 — the one source of "did the wasm init fail", as a promise.
//
// It used to be a `let failure` slot on `index.ts`, read synchronously when a
// reader's `import('../wasm')` resolved. Safari can hand back that namespace
// before the module body has run (2.10.26v), and the read then threw a TDZ
// `ReferenceError`. A promise that `initWasm` itself settles cannot be read
// too early: it resolves only once the init has really finished.
//
// NO TOP-LEVEL `await` HERE, AND NO VALUE IMPORT OF `./index`. This module is
// on the boot graph (`report.ts` and `main.tsx` import it statically), which
// must not reach the facade (25.9.26f AC1, `bootGraph.test.ts` 16.10.26p AC6).
// Its one import is type-only and erased at build.
//
// A reader awaits it only after its facade import has *resolved*: a rejected
// import means `index.ts` never ran, so this never settles.

import type { WasmInitFailure } from './report'

// Assigned synchronously by the executor below; the initialiser only satisfies definite assignment.
let settle: (failure: WasmInitFailure | null) => void = () => {}

/** Resolves once `initWasm` has finished: `null` on success, else what it recorded. Never rejects. */
export const wasmInitOutcome: Promise<WasmInitFailure | null> = new Promise((resolve) => {
  settle = resolve
})

/** Called once, by `wasm/index.ts`'s `initWasm`; a later call is a no-op (a promise resolves once). */
export function settleWasmInit(failure: WasmInitFailure | null): void {
  settle(failure)
}
